var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.254,
    height: 107.253,
    viewBox: "0 0 107.254 107.253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instagram",
    transform: "translate(118.588 118.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10212",
    "data-name": "Group 10212",
    transform: "translate(-118.588 -118.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10211",
    "data-name": "Group 10211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27577",
    "data-name": "Path 27577",
    d: "M71.029,29.384A10.259,10.259,0,0,0,65.144,23.5a17.162,17.162,0,0,0-5.757-1.068c-3.269-.149-4.25-.181-12.528-.181s-9.259.032-12.528.181A17.17,17.17,0,0,0,28.574,23.5a10.268,10.268,0,0,0-5.885,5.885,17.17,17.17,0,0,0-1.068,5.757c-.149,3.269-.181,4.25-.181,12.528s.032,9.259.181,12.528a17.162,17.162,0,0,0,1.068,5.757,10.268,10.268,0,0,0,5.885,5.885,17.17,17.17,0,0,0,5.757,1.068c3.269.149,4.25.181,12.528.181s9.259-.032,12.528-.181a17.162,17.162,0,0,0,5.757-1.068,10.259,10.259,0,0,0,5.885-5.885A17.162,17.162,0,0,0,72.1,60.2c.149-3.269.181-4.25.181-12.528s-.032-9.259-.181-12.528A17.17,17.17,0,0,0,71.029,29.384ZM46.859,63.591A15.922,15.922,0,1,1,62.781,47.669,15.92,15.92,0,0,1,46.859,63.591ZM63.409,34.84a3.721,3.721,0,1,1,3.72-3.721A3.72,3.72,0,0,1,63.409,34.84Z",
    transform: "translate(6.823 7.081)",
    fill: "#e7f0f4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 10.335,
    cy: 10.335,
    r: 10.335,
    transform: "translate(43.348 44.415)",
    fill: "#e7f0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27578",
    "data-name": "Path 27578",
    d: "M53.627,0a53.627,53.627,0,1,0,53.627,53.627A53.628,53.628,0,0,0,53.627,0ZM84.5,67.533a22.724,22.724,0,0,1-1.441,7.526,15.856,15.856,0,0,1-9.068,9.068,22.751,22.751,0,0,1-7.526,1.441c-3.306.152-4.362.187-12.783.187s-9.475-.036-12.783-.187a22.766,22.766,0,0,1-7.526-1.441,15.856,15.856,0,0,1-9.068-9.068,22.758,22.758,0,0,1-1.441-7.526c-.152-3.306-.187-4.362-.187-12.783s.036-9.475.187-12.783a22.765,22.765,0,0,1,1.441-7.526,15.856,15.856,0,0,1,9.068-9.068A22.765,22.765,0,0,1,40.9,23.932c3.307-.152,4.363-.187,12.783-.187s9.477.036,12.783.187a22.751,22.751,0,0,1,7.526,1.441,15.856,15.856,0,0,1,9.068,9.068A22.731,22.731,0,0,1,84.5,41.967c.152,3.307.187,4.362.187,12.783S84.651,64.227,84.5,67.533Z",
    fill: "#e7f0f4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/Instagram_icon.a43d30b7ed81db0418eba277f43b81c8.svg";
export { ForwardRef as ReactComponent };